/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type {
	PraetoidError,
	SelectEnvironmentRequest,
	SelectOrganizationRequest,
	SessionListResponse,
	SessionWithUser,
	SuccessResponse
} from '../models';

/**
 * Returns the current session with user information
 * @summary Get current session
 */
export const getCurrentSession = () => {
	return customInstance<SessionWithUser>({ url: `/account/session`, method: 'GET' });
};

export const getGetCurrentSessionQueryKey = () => {
	return ['account', 'session'] as const;
};

export const getGetCurrentSessionQueryOptions = <
	TData = Awaited<ReturnType<typeof getCurrentSession>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSession>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetCurrentSessionQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentSession>>> = () =>
		getCurrentSession();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getCurrentSession>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCurrentSessionQueryResult = NonNullable<
	Awaited<ReturnType<typeof getCurrentSession>>
>;
export type GetCurrentSessionQueryError = ErrorType<PraetoidError>;

export function useGetCurrentSession<
	TData = Awaited<ReturnType<typeof getCurrentSession>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSession>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getCurrentSession>>,
					TError,
					Awaited<ReturnType<typeof getCurrentSession>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCurrentSession<
	TData = Awaited<ReturnType<typeof getCurrentSession>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSession>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getCurrentSession>>,
					TError,
					Awaited<ReturnType<typeof getCurrentSession>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCurrentSession<
	TData = Awaited<ReturnType<typeof getCurrentSession>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSession>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get current session
 */

export function useGetCurrentSession<
	TData = Awaited<ReturnType<typeof getCurrentSession>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSession>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetCurrentSessionQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Deletes all user sessions except the current one
 * @summary Delete all sessions except current
 */
export const deleteAllSessions = () => {
	return customInstance<SessionListResponse>({ url: `/account/sessions`, method: 'DELETE' });
};

export const getDeleteAllSessionsMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteAllSessions>>,
		TError,
		void,
		TContext
	>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteAllSessions>>, TError, void, TContext> => {
	const mutationKey = ['deleteAllSessions'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAllSessions>>, void> = () => {
		return deleteAllSessions();
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteAllSessionsMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteAllSessions>>
>;

export type DeleteAllSessionsMutationError = ErrorType<PraetoidError>;

/**
 * @summary Delete all sessions except current
 */
export const useDeleteAllSessions = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteAllSessions>>,
			TError,
			void,
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof deleteAllSessions>>, TError, void, TContext> => {
	return useMutation(getDeleteAllSessionsMutationOptions(options), queryClient);
};
/**
 * Returns all active sessions for the authenticated user
 * @summary List user sessions
 */
export const listSessions = () => {
	return customInstance<SessionListResponse>({ url: `/account/sessions`, method: 'GET' });
};

export const getListSessionsQueryKey = () => {
	return ['account', 'sessions'] as const;
};

export const getListSessionsQueryOptions = <
	TData = Awaited<ReturnType<typeof listSessions>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListSessionsQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listSessions>>> = () => listSessions();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listSessions>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listSessions>>>;
export type ListSessionsQueryError = ErrorType<PraetoidError>;

export function useListSessions<
	TData = Awaited<ReturnType<typeof listSessions>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listSessions>>,
					TError,
					Awaited<ReturnType<typeof listSessions>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSessions<
	TData = Awaited<ReturnType<typeof listSessions>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listSessions>>,
					TError,
					Awaited<ReturnType<typeof listSessions>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSessions<
	TData = Awaited<ReturnType<typeof listSessions>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List user sessions
 */

export function useListSessions<
	TData = Awaited<ReturnType<typeof listSessions>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListSessionsQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Updates the current session to use the specified organization
 * @summary Select organization for session
 */
export const selectOrganization = (selectOrganizationRequest: SelectOrganizationRequest) => {
	return customInstance<SuccessResponse>({
		url: `/account/sessions`,
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		data: selectOrganizationRequest
	});
};

export const getSelectOrganizationMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof selectOrganization>>,
		TError,
		{ data: SelectOrganizationRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof selectOrganization>>,
	TError,
	{ data: SelectOrganizationRequest },
	TContext
> => {
	const mutationKey = ['selectOrganization'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof selectOrganization>>,
		{ data: SelectOrganizationRequest }
	> = (props) => {
		const { data } = props ?? {};

		return selectOrganization(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type SelectOrganizationMutationResult = NonNullable<
	Awaited<ReturnType<typeof selectOrganization>>
>;
export type SelectOrganizationMutationBody = SelectOrganizationRequest;
export type SelectOrganizationMutationError = ErrorType<PraetoidError>;

/**
 * @summary Select organization for session
 */
export const useSelectOrganization = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof selectOrganization>>,
			TError,
			{ data: SelectOrganizationRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof selectOrganization>>,
	TError,
	{ data: SelectOrganizationRequest },
	TContext
> => {
	return useMutation(getSelectOrganizationMutationOptions(options), queryClient);
};
/**
 * Updates the current session to use the specified environment
 * @summary Select environment for session
 */
export const selectEnvironment = (selectEnvironmentRequest: SelectEnvironmentRequest) => {
	return customInstance<SuccessResponse>({
		url: `/account/sessions/environment`,
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		data: selectEnvironmentRequest
	});
};

export const getSelectEnvironmentMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof selectEnvironment>>,
		TError,
		{ data: SelectEnvironmentRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof selectEnvironment>>,
	TError,
	{ data: SelectEnvironmentRequest },
	TContext
> => {
	const mutationKey = ['selectEnvironment'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof selectEnvironment>>,
		{ data: SelectEnvironmentRequest }
	> = (props) => {
		const { data } = props ?? {};

		return selectEnvironment(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type SelectEnvironmentMutationResult = NonNullable<
	Awaited<ReturnType<typeof selectEnvironment>>
>;
export type SelectEnvironmentMutationBody = SelectEnvironmentRequest;
export type SelectEnvironmentMutationError = ErrorType<PraetoidError>;

/**
 * @summary Select environment for session
 */
export const useSelectEnvironment = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof selectEnvironment>>,
			TError,
			{ data: SelectEnvironmentRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof selectEnvironment>>,
	TError,
	{ data: SelectEnvironmentRequest },
	TContext
> => {
	return useMutation(getSelectEnvironmentMutationOptions(options), queryClient);
};
/**
 * Deletes a specific session by its tracking ID
 * @summary Delete a session
 */
export const deleteSession = (id: string) => {
	return customInstance<SuccessResponse>({ url: `/account/sessions/${id}`, method: 'DELETE' });
};

export const getDeleteSessionMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteSession>>,
		TError,
		{ id: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteSession>>,
	TError,
	{ id: string },
	TContext
> => {
	const mutationKey = ['deleteSession'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSession>>, { id: string }> = (
		props
	) => {
		const { id } = props ?? {};

		return deleteSession(id);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteSessionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSession>>>;

export type DeleteSessionMutationError = ErrorType<PraetoidError>;

/**
 * @summary Delete a session
 */
export const useDeleteSession = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteSession>>,
			TError,
			{ id: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof deleteSession>>,
	TError,
	{ id: string },
	TContext
> => {
	return useMutation(getDeleteSessionMutationOptions(options), queryClient);
};
